import { createAndExecuteService } from '@utils/httpClient';
import { getUrl } from '@utils/utils';
import { AxiosResponse } from 'axios';
import {
  AddContactsToCartPayload,
  AddFrameToCartPayload,
  Config,
  EditSavedItemsContactQuantityPayload,
  EditSavedItemsGlassesWarrantyPayload,
  GetWishlistPayload,
} from './wishlistInterfaces';

export default {
  getEspot: async (config: Config, espotName: string): Promise<AxiosResponse> => {
    const url = getUrl(config, 'GET_ESPOT') + espotName;
    return await createAndExecuteService({ url, method: 'GET' });
  },
  getItemProperties: async (url: string): Promise<AxiosResponse> => {
    url = url + '?nocache=' + new Date().getTime();
    const res = await createAndExecuteService({ url, method: 'GET', withCredentials: true });

    return res;
  },
  getPrescription: async (config: Config, orderItemId: string): Promise<AxiosResponse> => {
    const url =
      getUrl(config, 'GET_PRESCRIPTION') + orderItemId + '?nocache=' + new Date().getTime();

    const res = await createAndExecuteService({
      url,
      method: 'GET',
      withCredentials: true,
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    });
    return res;
  },
  addFrameToCart: async (config: Config, data: AddFrameToCartPayload): Promise<AxiosResponse> => {
    const url = getUrl(config, 'ADD_FRAME_TO_CART') + '?nocache=' + new Date().getTime();
    const res = await createAndExecuteService({ url, method: 'POST', withCredentials: true, data });
    return res;
  },
  addContactsToCart: async (
    config: Config,
    data: AddContactsToCartPayload
  ): Promise<AxiosResponse> => {
    const url = getUrl(config, 'ADD_CONTACTS_TO_CART') + '?nocache=' + new Date().getTime();
    const res = await createAndExecuteService({ url, method: 'POST', withCredentials: true, data });
    return res;
  },
  deleteItem: async (config: Config, savedItemId: string): Promise<AxiosResponse> => {
    const url =
      getUrl(config, 'DELETE_ITEM_FROM_WISHLIST').replace('{savedItemId}', savedItemId) +
      '?nocache=' +
      new Date().getTime();
    const res = await createAndExecuteService({ url, method: 'DELETE', withCredentials: true });
    return res;
  },
  getWishlist: async (config: Config, payload: GetWishlistPayload): Promise<AxiosResponse> => {
    let url = '';
    if (config.brand === 'TO') {
      url = `${getUrl(config, 'GET_WISHLIST')}?nocache=${new Date().getTime()}&pageSize=${
        payload.pageSize
      }&pageNumber=${payload.pageNumber}&sortCode=${payload.sortValue}`;
    } else {
      url = `${getUrl(config, 'GET_WISHLIST')}?nocache=${new Date().getTime()}&pageSize=${
        payload.pageSize
      }&pageNumber=${payload.pageNumber}`;
    }
    const res = await createAndExecuteService({ url, method: 'GET', withCredentials: true });
    return res;
  },
  editSavedItemsContactQuantity: async (
    config: Config,
    payload: EditSavedItemsContactQuantityPayload
  ): Promise<AxiosResponse> => {
    const { savedItemId, ...data } = payload;
    const url =
      getUrl(config, 'EDIT_SAVED_ITEMS_CONTACT_QUANTITY').replace('{savedItemId}', savedItemId) +
      '?nocache=' +
      new Date().getTime();

    const res = await createAndExecuteService({
      url,
      method: 'POST',
      withCredentials: true,
      data,
    });
    return res;
  },
  editSavedItemsGlassesWarranty: async (
    config: Config,
    payload: EditSavedItemsGlassesWarrantyPayload
  ): Promise<AxiosResponse> => {
    const url =
      getUrl(config, 'EDIT_SAVED_ITEMS_GLASSES_WARRANTY').replace(
        '{savedItemId}',
        payload.savedItemId
      ) +
      '?nocache=' +
      new Date().getTime();

    const res = await createAndExecuteService({
      url,
      method: 'POST',
      withCredentials: true,
      data: { warranty: payload.warrantyValue },
    });
    return res;
  },
};
